/*@ngInject*/
const SupplementalFormUtil = function ($rootScope, formViewerConstant, formViewerUtil) {

    this.deleteSupplementalForm = function (supplementalForm, sectionList, fieldMap) {
        let supplementalFormId = supplementalForm.id;

        function removeFieldsFromFieldMap(supplementalSectionList) {
            function removeFieldEntries(fieldStructureList) {
                _.eachRight(fieldStructureList, function (fieldStructure) {
                    let fieldKey = fieldStructure.uiField.fieldTemplate.id;
                    if (fieldStructure.rowInstanceId) {
                        fieldKey += '-' + fieldStructure.rowInstanceId;
                    }
                    fieldMap.remove(fieldKey);
                });
            }

            _.eachRight(supplementalSectionList, function (section) {
                _.eachRight(section.rowList, function (row) {
                    if (row.sectionList) {
                        removeFieldsFromFieldMap(row.sectionList);
                    }
                    if (row.rowList) {
                        _.eachRight(row.rowList, function (rowRepeater) {
                            removeFieldEntries(rowRepeater.fieldStructureList);
                        });
                    }
                    removeFieldEntries(row.fieldStructureList);
                });
            });
        }

        function searchSections(sectionList) {
            _.each(sectionList, function (section) {
                searchRows(section.rowList, section);
            });
        }

        function searchRows(rowList) {
            _.each(rowList, function (row, index) {
                if (row && row.sectionList && row.formModel.id === supplementalFormId) {
                    $rootScope.$broadcast(formViewerConstant.event.SUPPLEMENTAL_FORM_REMOVED, row.formName, row.formModel.rootFormId, supplementalFormId, row.sectionList);
                    removeFieldsFromFieldMap(row.sectionList);
                    rowList.splice(index, 1);
                }
                else if (row && !_.isEmpty(row.sectionList)) {
                    searchSections(row.sectionList);
                }
            });
        }

        searchSections(sectionList);
    };

    this.doesPrecedingFormExist = function (precedingFieldVariableName, precedingFieldFormTemplateUniqueName, rootFormSectionList) {
        return _.isUndefined(formViewerUtil.findPrecedingFieldRowForSupplementalForm(precedingFieldVariableName, precedingFieldFormTemplateUniqueName, rootFormSectionList)) !== true;
    };

    this.insertSupplementalForm = function (supplementalForm, sectionList) {
        let precedingFieldVariableName = supplementalForm.uiFormTemplate.precedingFieldVariableName;
        let precedingFieldFormTemplateUniqueName = supplementalForm.uiFormTemplate.precedingFieldFormTemplateUniqueName;
        let precedingFieldInfo = formViewerUtil.findPrecedingFieldRowForSupplementalForm(precedingFieldVariableName, precedingFieldFormTemplateUniqueName, sectionList);

        precedingFieldInfo.precedingFieldSection.sectionHeight += supplementalForm.formHeight;
        precedingFieldInfo.precedingFieldSection.rowList.splice(precedingFieldInfo.precedingFieldRowIndex + 1, 0, supplementalForm);
        supplementalForm.parentForm = precedingFieldInfo.precedingFieldRow.parentFormStructure;
    };

};

angular.module('umFormViewer')
    .service('supplementalFormUtil', SupplementalFormUtil);
